import { Button, Typography } from "@mui/material";
import { Formik } from "formik";
import * as yup from "yup";
import FormikDatePicker from "../../../../commons/formik/FormikDatePicker";
import FormikTextField from "../../../../commons/formik/FormikTextField";
import CircularLoading from "../../../../commons/loading/CircularLoading";
import { StyledCoberturaViajeAlExterior } from "../../../../styled/Personal";

const validationSchema = yup.object({
  fechaViajeDesde: yup
    .date()
    .required("Campo obligatorio")
    .nullable()
    .typeError("Fecha inválida"),
  fechaViajeHasta: yup
    .date()
    .required("Campo obligatorio")
    .nullable()
    .typeError("Fecha inválida")
    .test({
      name: "fechaViajeHasta",
      message: "La fecha hasta debe ser mayor a la fecha desde",
      test: function (value) {
        return value && this.parent.fechaViajeDesde
          ? value > this.parent.fechaViajeDesde
          : true;
      },
    }),
  destino: yup
    .string()
    .required("Campo obligatorio")
    .max(255, "El campo debe contener maxino 255 caracteres"),
  coberturaSaludExterior: yup
    .string()
    .required("Campo obligatorio")
    .max(1000, "El campo debe contener maxino 1000 caracteres"),
});

const DatosDelViaje = ({ handleSubmit, formModel }) => {

  return (
    <StyledCoberturaViajeAlExterior.Container>
      <StyledCoberturaViajeAlExterior.ContentContainer sx={{ margin: "auto" }}>
        {formModel ? (
          <Formik
            initialValues={formModel}
            validationSchema={validationSchema}
            onSubmit={handleSubmit}
          >
            <StyledCoberturaViajeAlExterior.Form>
              <div>
                <Typography>Fecha del Viaje</Typography>
                <StyledCoberturaViajeAlExterior.DatesInputContainer>
                  <StyledCoberturaViajeAlExterior.DatePicker>
                    <FormikDatePicker
                      name="fechaViajeDesde"
                      label="Fecha desde *"
                      ampm="false"
                      format="dd/MM/yyyy"
                      variant="inline"
                    />
                  </StyledCoberturaViajeAlExterior.DatePicker>
                  <StyledCoberturaViajeAlExterior.DatePicker>
                    <FormikDatePicker
                      name="fechaViajeHasta"
                      label="Fecha hasta *"
                      ampm="false"
                      format="dd/MM/yyyy"
                      variant="inline"
                    />
                  </StyledCoberturaViajeAlExterior.DatePicker>
                </StyledCoberturaViajeAlExterior.DatesInputContainer>
              </div>
              <FormikTextField
                fullWidth={true}
                id="destino"
                name="destino"
                type="text"
                label="Destino *"
                variant="outlined"
              />
              <FormikTextField
                fullWidth={true}
                id="coberturaSaludExterior"
                name="coberturaSaludExterior"
                type="text"
                label="Cobertura médica en el exterior *"
                variant="outlined"
              />
              <StyledCoberturaViajeAlExterior.ButtonContainer>
                <Button type="submit" color="primary" variant="contained">
                  Siguiente
                </Button>
              </StyledCoberturaViajeAlExterior.ButtonContainer>
            </StyledCoberturaViajeAlExterior.Form>
          </Formik>
        ) : (
          <CircularLoading />
        )}
      </StyledCoberturaViajeAlExterior.ContentContainer>
    </StyledCoberturaViajeAlExterior.Container>
  );
};

export default DatosDelViaje;
